import React, { CSSProperties, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import StyledMain from './styled/StyledMain';
import SideMenu from '../../components/drawer/BkDrawer';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import DefaultMain from './DefaultMain';
import SettingsPage from '../settings/Settings';
import { setUrl } from '../../features/stepper/stepperSlice';
import JobHistory from '../job-history/JobHistory';
import CostEstimator from '../cost-estimator/CostEstimator';
import BkSnackBar from '../../components/snackbar/BkSnackBar';
import { CompanyPage } from '../admin/company/CompanyPage';
import { Banner } from 'src/components/new/Banner';
import Pricing from '../admin/pricing/Pricing';
import PartnerAPIPage from '../admin/partner-api/PartnerAPIPage';
import { JobHistoryPage } from '../admin/jobs/JobHistory';
import { getActiveBanner } from 'src/features/user/utils';
import { setBannerStatus } from 'src/features/user/userSlice';
import { getPaymentMethods } from 'src/features/company/utils';
import { OrganizationType } from 'src/utils/enums/organization-type.enum';

const wrapperDivStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
};

const BkDashboard: React.FC = () => {
  const location = useLocation();

  const dispatch = useDispatch<AppDispatch>();

  const activeUrl = useSelector((state: RootState) => state.stepper.activeUrl);
  const currentUser = useSelector((state: RootState) => state.user.currentUser);
  const bannerStatus = useSelector((state: RootState) => state.user.bannerStatus);

  const { success } = location.state || {};

  const [open, setOpen] = useState<boolean>(true);

  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(success || false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const components: { [key: string]: React.ReactNode } = {
    '/home': ['admin', 'support'].includes(currentUser.teamRole) ? <Navigate to="/admin-history" replace /> : <DefaultMain />,
    '/settings': currentUser.teamRole === null ? <SettingsPage /> : <Navigate to="/home" replace />,
    '/history': currentUser.teamRole === null ? <JobHistory /> : <Navigate to="/home" replace />,
    '/costs': currentUser.teamRole === null ? <CostEstimator /> : <Navigate to="/home" replace />,
    '/admin-pricing': currentUser.teamRole === 'admin' ? <Pricing /> : <Navigate to="/home" replace />,
    '/admin-company': currentUser.teamRole === 'admin' ? <CompanyPage /> : <Navigate to="/home" replace />,
    '/admin-partner': currentUser.teamRole === 'admin' ? <PartnerAPIPage /> : <Navigate to="/home" replace />,
    '/admin-history': currentUser.teamRole !== null ? <JobHistoryPage /> : <Navigate to="/home" replace />,
  };

  useEffect(() => {
    if (location) {
      const pathname = location.pathname;
      dispatch(setUrl(pathname));
    }
  }, [location]);

  useEffect(() => {
    if (!currentUser.accessToken) {
      return;
    }
    dispatch(getActiveBanner()).then((result) => {
      if (result.payload) {
        dispatch(setBannerStatus(result.payload.activeNotification));
      }
    });
    if (!currentUser.teamRole && currentUser.organization.type !== OrganizationType.CHAPTER_13_TRUSTEE) {
      dispatch(getPaymentMethods());
    }
  }, [currentUser.accessToken]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const onBannerClose = () => {
    dispatch(setBannerStatus(null));
  };

  return (
    <>
      {bannerStatus && <Banner onClose={onBannerClose} type={bannerStatus} />}
      <div style={{ paddingBottom: '1.875rem', marginTop: !!bannerStatus ? '1.875rem' : '' }}>
        <div style={wrapperDivStyles}>
          <SideMenu isBannerActive={!!bannerStatus} open={open} handleToggle={handleDrawerToggle} />
          <StyledMain open={open}>{components[activeUrl]}</StyledMain>
        </div>
        <BkSnackBar
          open={snackbarOpen}
          handleCloseSnackbar={handleSnackbarClose}
          snackMessage="Default information saved! Now you can create your first notice"
          severity="success"
        />
      </div>
    </>
  );
};

export default BkDashboard;
